/**
 * Shared hero background image tuning (Sanity CDN + build-time preload).
 * Denser widths so mobile avoids jumping 640w → 960w when layout ~720px wide.
 */
export const HERO_BACKGROUND_IMAGE_SRCSET_WIDTHS = [
  480, 640, 720, 960, 1280, 1920,
] as const;

export const HERO_BACKGROUND_IMAGE_QUALITY = 72;
